module.exports = __webpack_public_path__ + "static/media/logo-google-play.2cad0afb.svg";